import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { getTheme, setTheme } from '../../lib/theme';
import styles from './Layout.module.css';

export function Layout() {
  const [pinned, setPinned] = useState<boolean>(() => {
    return localStorage.getItem('sidebar-pinned') === 'true';
  });

  /* Bootstrap the saved theme onto <html> once on mount. The ThemeToggle in the
     sidebar footer owns changes thereafter (via lib/theme), so Layout no longer
     holds theme state or plumbs it through the Header. */
  useEffect(() => {
    setTheme(getTheme());
  }, []);

  useEffect(() => {
    localStorage.setItem('sidebar-pinned', String(pinned));
  }, [pinned]);

  return (
    <div className={styles.layout}>
      <Sidebar pinned={pinned} onPinnedChange={setPinned} />
      <div
        className={`app-main ${styles.mainWrapper}`}
        data-sidebar-pinned={pinned ? '' : undefined}
      >
        <Header />
        <main className={styles.main}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
